/**
 * 홈페이지 포토갤러리 섹션 컴포넌트
 * 최신 포토갤러리 미리보기를 표시합니다.
 */

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Preview from '../Preview';
import { getPhotos } from '../../Api';
import { useIsDesktop } from '../../hooks/useMediaQuery';

// 이미지 import
import moreImg from '../../assets/more.png';

/**
 * PhotoGallerySection 컴포넌트
 * 데스크톱과 모바일에서 다른 헤더 스타일로 포토갤러리를 표시합니다.
 */
function PhotoGallerySection() {
  const isDesktop = useIsDesktop();

  return (
    <PhotoGallery>
      {isDesktop ? (
        <PhotoTitleHeader>
          <PhotoTitle>포토갤러리</PhotoTitle>
          <MoreLink to="/photo">
            <img src={moreImg} width="20px" alt="포토갤러리 더보기" />
          </MoreLink>
        </PhotoTitleHeader>
      ) : (
        <MobileHeader>
          <MobileHeaderTitle>포토갤러리</MobileHeaderTitle>
          <MobileHeaderMore to="/photo">
            <img src={moreImg} width="20px" alt="포토갤러리 더보기" />
          </MobileHeaderMore>
        </MobileHeader>
      )}
      <Preview address="/photo" getdata={getPhotos} isPhoto={true} />
    </PhotoGallery>
  );
}

export default PhotoGallerySection;

/* Styled Components */

const PhotoGallery = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  flex: 1;
  height: 252px;
  border: 1px solid #d7d7d7;
  background: #fff;

  > ul {
    margin: 0 auto;
    margin-top: 20px;
    width: calc(100% - 44px);
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    list-style: none;
    padding: 0;

    > li {
      margin: 0 !important;
      padding: 0 !important;
      list-style: none !important;
    }
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    border: none;
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
    padding-bottom: 20px;

    > ul {
      width: 90%;
      margin-top: 15px;
      gap: 15px;
      flex-direction: column;
    }
  }
`;

const PhotoTitle = styled.h3`
  /* 데스크톱 기본 스타일 */
  width: 100%;
  height: 48px;
  line-height: 48px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #cdcdcd;
  font-family: 'Nanum Gothic Bold';
  font-size: 17px;
  color: #323232;
  padding-left: 22px;
  margin: 0;
  box-sizing: border-box;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 90%;
    padding-left: 5%;
    font-size: 16px;
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
  }
`;

const PhotoTitleHeader = styled.div`
  position: relative;
  width: 100%;
`;

const MoreLink = styled(Link)`
  /* 데스크톱 기본 스타일 */
  position: absolute;
  right: 10px;
  top: 15px;
  width: 30px;
  height: 10px;
  display: block;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    right: 5%;
    top: 10px;
  }
`;

// 공용 모바일 헤더
const MobileHeader = styled.div`
  position: relative;
  width: 90%;
  margin: 0 auto 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MobileHeaderTitle = styled.h3`
  margin: 0;
  font-family: 'Nanum Gothic Bold';
  font-weight: bold;
  color: #333333;
  font-size: 18px;

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 22px;
  }
`;

const MobileHeaderMore = styled(Link)`
  position: static;
  width: 20px;
  height: 20px;
  display: inline-block;
`;
